import { Form, FormInstance, Input, Result } from 'antd'
import { useAppSelector } from '../../../reducers/hooks'
import { requiredRule } from '../../../utils/rules'
import { useIntl } from 'react-intl'
import { useEffect } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { selectSelectedBanner } from '../../../reducers/BannerReducer'

interface Props {
  form: FormInstance
}

const Delete = ({ form }: Props) => {
  const intl = useIntl()
  const file = useAppSelector(selectSelectedBanner())

  useEffect(() => {
    form.setFieldsValue(file)
  }, [file])

  return file ? (
    <Form form={form} layout="vertical">
      <Result
        title="Are you sure to delete this banner ?"
        icon={<QuestionCircleOutlined style={{ color: 'orange' }} />}
      />
      <Form.Item
        name="id"
        required
        rules={[requiredRule(intl)]}
        className="d-none"
      >
        <Input type="hidden" />
      </Form.Item>
    </Form>
  ) : (
    <></>
  )
}

export default Delete
